import PropTypes from 'prop-types';
import React from 'react';
import { SCLoader } from 'rollup-allspark';
import { isEmpty } from '../../../utils';

/**
 * Slide-down panel listing the caller's past conversations for the active
 * business. Reopening one loads its history (contract §1).
 */
const ConversationSwitcher = ({
  open,
  conversations,
  loading,
  activeId,
  onSelect,
  onNewChat,
}) => {
  if (!open) return null;

  return (
    <div className="absolute inset-x-0 top-full z-20 max-h-80 overflow-y-auto border-b border-grey bg-white shadow-md">
      <button
        type="button"
        onClick={onNewChat}
        className="flex w-full items-center gap-x-2 border-b border-grey-light px-4 py-3 text-left text-sm font-medium text-primary hover:bg-primary-lightest"
      >
        <i className="kt-add" />
        New conversation
      </button>

      {loading ? (
        <div className="flex justify-center py-6">
          <SCLoader diameter={22} lineWidth={2} />
        </div>
      ) : isEmpty(conversations) ? (
        <div className="px-4 py-6 text-center text-xs text-grey-darker">
          No past conversations yet.
        </div>
      ) : (
        conversations.map(c => (
          <button
            key={c.id}
            type="button"
            onClick={() => onSelect(c.id)}
            className={`flex w-full flex-col gap-y-0.5 border-b border-grey-light px-4 py-3 text-left hover:bg-grey-lighter ${
              c.id === activeId ? 'bg-primary-lightest' : ''
            }`}
          >
            <span className="truncate text-sm font-medium text-black">
              {c.title || 'Untitled conversation'}
            </span>
            {c.summary ? (
              <span className="line-clamp-1 text-xs text-grey-darker">
                {c.summary}
              </span>
            ) : null}
          </button>
        ))
      )}
    </div>
  );
};

ConversationSwitcher.propTypes = {
  open: PropTypes.bool,
  conversations: PropTypes.array,
  loading: PropTypes.bool,
  activeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onSelect: PropTypes.func.isRequired,
  onNewChat: PropTypes.func.isRequired,
};

export default ConversationSwitcher;
